import { useState, useEffect } from "react";
import FormInputField from "../Global/FormInputField";
import useApiServices from "../../Utils/useApiService";
import { UPDATE_VENDER_MOBILE } from "../../Utils/Constants";
import swal from "sweetalert";
import { closeModal } from "../../Utils/handleModal";

const EditVendorMobile = ({ data, setEditVendorData, refetchVendors }) => {
    const [formData, setFormData] = useState({
        mobile: "",
    });

    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const { apiCallFnforPut } = useApiServices();

    // ✅ Prefill with vendor data
    useEffect(() => {
        if (data?.mobile) {
            setFormData({ mobile: data.mobile });
        }
    }, [data]);

    // ✅ Handle input change
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "mobile") {
            // Allow only numbers
            if (/^\d{0,10}$/.test(value)) {
                setFormData({ mobile: value });
                setError("");
            }
        }
    };

    // ✅ Submit update
    const handleSubmit = async () => {
        const { mobile } = formData;

        if (!mobile) {
            setError("*Please enter mobile number");
            return;
        }

        if (!/^[6-9]\d{9}$/.test(mobile)) {
            setError("*Please enter valid 10-digit mobile number");
            return;
        }

        try {
            setIsLoading(true);
            const payload = {
                vendorId: data?.vendorId,
                mobile,
            };

            const response = await apiCallFnforPut(`${UPDATE_VENDER_MOBILE}/${data?.vendorId}?mobileNumber=${mobile}`, payload);
            if (response?.statusCode === 200) {
                refetchVendors();
                swal("Success", "Mobile number updated successfully!", "success");
                setEditVendorData({});
                closeModal("editVendorMobileNumber");
            } else {
                swal("Error", response?.message || "Failed to update mobile number.", "error");
            }
        } catch (error) {
            const errMessage =
                error?.response?.data?.message ||
                error?.response?.message ||
                error?.message ||
                "Something went wrong.";
            swal("Error", errMessage, "error");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <div className="w-100">
                <FormInputField
                    label="Mobile Number"
                    required
                    name="mobile"
                    type="tel"
                    value={formData.mobile}
                    placeholder="Enter mobile number"
                    onChange={handleChange}
                    errorText={error}
                    maxLength={10}
                    fullWidth
                />
            </div>

            <div className="col-12 mt-3">
                <div className="form-group d-flex justify-content-end gap-3">
                    <button
                        id="updateVendorMobile"
                        className="advanced-btn btn btn-primary btn-sm"
                        onClick={handleSubmit}
                        disabled={isLoading}
                    >
                        {isLoading ? "Updating..." : "Save Changes"}
                    </button>
                </div>
            </div>
        </>
    );
};

export default EditVendorMobile;